// extracted by mini-css-extract-plugin
export default {"container":"ClassificationEditor_container__s1zWQ","flipButton":"ClassificationEditor_flipButton__uB2tO"};